<template>
  <div id="operationFormContent" class="flex layout-column pa-1" style="overflow-y: auto;">
    <div>
      <lx-expansion-panels :single-open="false" v-model="panel">

        <!--   Melder  (panel 0)   -->

        <lx-expansion-panel :disabled="true" :isInvalid="openInvalidModule(0, 'report_header')">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-account-edit"
                                     :main-headline="$t('FORMS_DIVERSE.REPORTER_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.REPORTER_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="report_header">
              <div class="pa-4 layout-row layout-wrap">
                <melder path="report_header"
                        :isDisabled="isFormDisabled()"
                        :validationRef="validationRef"
                        :isMedicalCommunity="isMedicalCommunity"
                        v-model="model.report_header"
                        :additionalItemsList="additionalItemsList"
                        class="layout-row layout-wrap flex-gt-sm-100 flex-100"></melder>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Grunddaten   (panel 1)  -->

        <lx-expansion-panel :disabled="true" :isInvalid="openInvalidModule(1, 'base')">
          <lx-expansion-panel-header :disabled="true"
                                     :main-headline="$t('FORMS_DIVERSE.BASE_OPERATION_HEADER')"
                                     icon="healing"
                                     :sub-headline="$t('FORMS_DIVERSE.BASE_OPERATION_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="base">
              <div class="pa-4 layout-row layout-wrap">
                <base-data path="base"
                           :key="'BaseDataOperation' + formId"
                           :patientId="patientId"
                           :formId="formId"
                           :isDisabled="isFormDisabled()"
                           :addOPSItem="addItem" :deletOpsItem="deleteItem"
                           v-model="model.base"
                           :validationRef="validationRef"
                           class="layout-row layout-wrap flex-gt-sm-100 flex-100"></base-data>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Malignes Melanom bei Diagnose C43* (panel 2) -->

        <lx-expansion-panel :disabled="true"
                            :isInvalid="openInvalidModule(2, 'modul_malignes_melanom')"
                            v-show="showModuleInDependencyToICD10('malignes', model.patient_id)">
          <lx-expansion-panel-header :disabled="true"
                                     icon="mdi-hexagon-multiple"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_MALIGNES_MELANOM_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_MALIGNES_MELANOM_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="modul_malignes_melanom">
              <div class="pa-4 layout-row layout-wrap">
                <malignes-melanom path="modul_malignes_melanom"
                                  :base="model.diagnose"
                                  :tnm="model.tnm"
                                  :validationRef="validationRef"
                                  formKey="operation"
                                  :isDisabled="isFormDisabled()"
                                  v-model="model.modul_malignes_melanom"
                                  class="layout-row layout-wrap flex-gt-sm-100 flex-100"></malignes-melanom>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Mamma bei Diagnosen C50 und D05  (panel 3)-->

        <lx-expansion-panel :disabled="true"
                            :isInvalid="openInvalidModule(3, 'modul_mamma')"
                            v-show="showModuleInDependencyToICD10('mamma', model.patient_id)">
          <lx-expansion-panel-header :disabled="true"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_MAMMA_HEADER')"
                                     icon="mdi-human-female"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_MAMMA_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="modul_mamma">
              <div class="pa-4 layout-row layout-wrap">
                <modul-mamma path="modul_mamma"
                             :base="model.diagnose"
                             formKey="operation"
                             :validationRef="validationRef"
                             :isDisabled="isFormDisabled()"
                             v-model="model.modul_mamma"
                             class="layout-row layout-wrap flex-gt-sm-100 flex-100"></modul-mamma>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Kolo bei Diagnosen C18, C19, C20, D01.0, D01.1, D01.2  (panel 4)-->

        <lx-expansion-panel :disabled="true"
                            :isInvalid="openInvalidModule(4, 'modul_darm')"
                            v-show="showModuleInDependencyToICD10('kolo', model.patient_id)">
          <lx-expansion-panel-header :disabled="true"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_KOLO_HEADER')"
                                     icon="mdi-emoticon-poop"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_KOLO_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="modul_darm">
              <div class="pa-4 layout-row layout-wrap">
                <modul-kolo path="modul_darm"
                            :base="model.diagnose"
                            formKey="operation"
                            :validationRef="validationRef"
                            :isDisabled="isFormDisabled()"
                            v-model="model.modul_darm"
                            class="layout-row layout-wrap flex-gt-sm-100 flex-100"></modul-kolo>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Prostata bei Diagnosen C61 und D07.5  (panel 5)-->

        <lx-expansion-panel :disabled="true"
                            :isInvalid="openInvalidModule(5, 'modul_prostata')"
                            v-show="showModuleInDependencyToICD10('prostata', model.patient_id)">
          <lx-expansion-panel-header :disabled="true"
                                     :main-headline="$t('FORMS_DIVERSE.MODULE_PROSTATA_HEADER')"
                                     icon="mdi-human-male"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_PROSTATA_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="modul_prostata">
              <div class="pa-4 layout-row layout-wrap">
                <modul-prostata path="modul_prostata"
                                :base="model.base"
                                :patientId="patientId"
                                formKey="operation"
                                :validationRef="validationRef"
                                :isDisabled="isFormDisabled()"
                                v-model="model.modul_prostata"
                                class="layout-row layout-wrap flex-gt-sm-100 flex-100"></modul-prostata>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Histologie    (panel 6) -->

        <lx-expansion-panel :isInvalid="openInvalidModule(6, 'histologie')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.HISTOLOGY_HEADER')"
                                     icon="mdi-stethoscope"
                                     :sub-headline="$t('FORMS_DIVERSE.HISTOLOGY_SINGLE_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="histologie">
              <div class="pa-4 layout-row layout-wrap">
                <histologie path="histologie"
                            :isRequired="false"
                            :patientId="patientId"
                            :isDisabled="isFormDisabled()"
                            :validationRef="validationRef"
                            v-model="model.histologie"
                            class="layout-row layout-wrap flex-gt-sm-100 flex-100"></histologie>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   TNM   (panel 7)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(7, 'tnm')">
          <lx-expansion-panel-header main-headline="TNM"
                                     icon="mdi-hexagon-multiple-outline"
                                     :sub-headline="$t('FORMS_DIVERSE.TNM_HEADER_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="tnm">
              <div class="pa-4 layout-row layout-wrap">
                <tnm path="tnm"
                     :patientId="patientId"
                     :diagCode="diagCode"
                     :diagDate="diagDate"
                     :isDisabled="isFormDisabled()"
                     v-model="model.tnm"
                     :validationRef="validationRef"
                     class="layout-row layout-wrap flex-gt-sm-100 flex-100"></tnm>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Weitere Klassifikationen  (panel 8)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(8, 'weitere_klassifikation')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.FURTHER_CLASSIFICATION_HEADER')"
                                     icon="mdi-vector-polyline"
                                     :sub-headline="$t('FORMS_DIVERSE.FURTHER_CLASSIFICATION_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <weitere-klassifikationen path="weitere_klassifikation"
                                      :patientId="patientId"
                                      :validationRef="validationRef"
                                      :isDisabled="isFormDisabled()"
                                      v-model="model.weitere_klassifikation"
                                      v-bind="{addItem, deleteItem}"
                                      class="layout-wrap flex-gt-sm-100 flex-100"></weitere-klassifikationen>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Residualstatus   (panel 9)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(9, 'residualstatus')"
                            :disabled="true">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.MODULE_RESIDUAL_STATUS_HEADER')"
                                     :disabled="true"
                                     icon="mdi-prescription"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_RESIDUAL_STATUS_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="residualstatus">
              <div class="pa-4 layout-row layout-wrap">
                <residualstatus path="residualstatus"
                                :isRequired="true"
                                :isDisabled="isFormDisabled()"
                                v-model="model.residualstatus"
                                class="layout-row layout-wrap flex-gt-sm-100 flex-100"></residualstatus>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   OP-Komplikationen   (panel 10)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(10, 'op_komplikation')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.MODULE_OP_COMPLICATIONS_HEADER')"
                                     icon="mdi-alert-circle"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_OP_COMPLICATIONS_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="1500">
            <ValidationObserver tag="div" ref="op_komplikation">
              <div class="pa-4 layout-row layout-wrap">
                <op-komplikationen path="op_komplikation"
                                   :validationRef="validationRef"
                                   :addNewItem="addItem"
                                   :isDisabled="isFormDisabled()"
                                   v-model="model.op_komplikation"
                                   class="layout-row layout-wrap flex-gt-sm-100 flex-100"></op-komplikationen>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Genetische Varianten   (panel 11)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(11, 'genetische_varianten')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.GENETIC_VARIANT_HEADER')"
                                     icon="mdi-dna"
                                     :sub-headline="$t('FORMS_DIVERSE.GENETIC_VARIANT_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="genetische_varianten">
              <genetische-variante path="genetische_varianten"
                                   :isDisabled="isFormDisabled()"
                                   :patientId="patientId"
                                   v-model="model.genetische_varianten"
                                   :validationRef="validationRef"
                                   :addNewItem="addItem"
                                   :deleteSelectedItem="deleteItem"
                                   class="layout-wrap flex-gt-sm-100 flex-100"></genetische-variante>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Modul Allgemein   (panel 12) -->

        <lx-expansion-panel>
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.MODULE_COMMON_HEADER')"
                                     icon="mdi-phone-classic"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_COMMON_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <div class="px-4 pt-4 layout-row layout-wrap">
              <modul-allgemein path="modul_allgemein"
                               :isDisabled="isFormDisabled()"
                               :validationRef="validationRef"
                               v-model="model.modul_allgemein"
                               class="layout-wrap flex-gt-sm-100 flex-100"></modul-allgemein>
            </div>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Operateure   (panel 13) -->

        <lx-expansion-panel :isInvalid="openInvalidModule(13, 'operateure')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.MODULE_SURGEON_HEADER')"
                                     icon="mdi-doctor"
                                     :sub-headline="$t('FORMS_DIVERSE.MODULE_SURGEON_SUB_LINE')">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="operateure">
              <operateure path="operateure"
                          :isDisabled="isFormDisabled()"
                          v-bind="{addItem, deleteItem}"
                          v-model="model.operateure"
                          :validationRef="validationRef"
                          class="layout-wrap flex-gt-sm-100 flex-100"></operateure>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>

        <!--   Anmerkung  (panel 14)  -->

        <lx-expansion-panel :isInvalid="openInvalidModule(14, 'anmerkung')">
          <lx-expansion-panel-header :main-headline="$t('FORMS_DIVERSE.ANNOTATION_HEADER')"
                                     :sub-headline="$t('FORMS_DIVERSE.ANNOTATION_SUB_LINE')"
                                     icon="mdi-lead-pencil">
          </lx-expansion-panel-header>
          <lx-expansion-panel-content :delay="500">
            <ValidationObserver tag="div" ref="anmerkung">
              <div class="px-4 pt-4 layout-row layout-wrap">
                <anmerkung path="anmerkung"
                           :isDisabled="isFormDisabled()"
                           v-model="model.anmerkung"
                           class="layout-wrap flex-gt-sm-100 flex-100"></anmerkung>
              </div>
            </ValidationObserver>
          </lx-expansion-panel-content>
        </lx-expansion-panel>
      </lx-expansion-panels>
    </div>
  </div>
</template>

<script>
import baseData from '../shared/GrunddatenOperation'
import malignesMelanom from '../shared/ModulMalignesMelanom'
import modulMamma from '../shared/ModulMamma'
import modulKolo from '../shared/ModulKolo'
import modulProstata from '../shared/ModulProstata'
import histologie from '../shared/Histologie'
import tnm from '../shared/TNM'
import weitereKlassifikationen from '../shared/WeitereKlassifikation'
import residualstatus from '../shared/Residualstatus'
import opKomplikationen from '../shared/OpKomplikationen'
import modulAllgemein from '../shared/ModulAllgemein'
import operateure from '../shared/Operateure'
import anmerkung from '../shared/Anmerkung'
import melder from '../shared/Melder'
import genetischeVariante from '../shared/GenetischeVariante.vue'

import utils from '../../../common/utils'
import lodash from 'lodash'

export default {
  name: 'Operation',
  mixins: [utils],
  components: {
    baseData,
    malignesMelanom,
    modulMamma,
    modulKolo,
    modulProstata,
    histologie,
    tnm,
    weitereKlassifikationen,
    residualstatus,
    opKomplikationen,
    modulAllgemein,
    operateure,
    anmerkung,
    melder,
    genetischeVariante
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    modulesAreEmpty: {
      type: Object,
      default: () => ({})
    },
    // is used to mark headers of invalid modules after trying to complete form (function in utils)
    setIsCompletedIsTriggered: {
      type: Boolean,
      default: false
    },
    patientId: {
      type: String
    },
    additionalItemsList: {
      type: Array,
      default: () => ([])
    },
    formId: {
      type: String
    }
  },
  data () {
    return {
      model: {
        key: 'operation'
      },
      panel: []
    }
  },
  created () {
    this.panel = lodash.clone(this.modulesAreEmpty.defaultPanel)
  },
  computed: {
    isMedicalCommunity () {
      const user = this.authStore.getters.getAuthUserData && this.authStore.getters.getAuthUserData.user ? this.authStore.getters.getAuthUserData.user : {}
      return user.cancer_form_details && user.cancer_form_details.isMedicalCommunity
    },
    diagDate () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).diagDate : undefined
    },
    diagCode () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).diagCode : undefined
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue

          // scroll to top, if new form
          if (!this.formId) {
            const myDiv = document.getElementById('operationFormContent')
            if (myDiv) {
              myDiv.scrollTop = 0
            }
          }
        }
      },
      immediate: true
    },
    'modulesAreEmpty.modules': {
      handler: function () {
        this.panel = lodash.clone(this.modulesAreEmpty.defaultPanel)

        const self = this
        Object.keys(this.modulesAreEmpty.modules).forEach(key => {
          // push index of filled modules in panel (selected modules are not opened via default)
          if (!self.modulesAreEmpty.modules[key].value && self.panel.indexOf(self.modulesAreEmpty.modules[key].index) < 0) {
            this.$nextTick(() => {
              self.panel.push(self.modulesAreEmpty.modules[key].index)
            })
          }
        })
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

